module.exports = __webpack_public_path__ + "img/996.020fa3b8.png";